import { createSlice } from '@reduxjs/toolkit';
import { getJobDefinitions } from 'ducks/job-definitions/operators';
import { normalizeJobDefinitions } from 'ducks/job-definitions/utils';
import { Slices } from 'ducks/slices';
import { JobDefinitionItem } from 'ducks/types/store-types';
import { NullableNumberInterface } from 'ducks/types/type-helpers';

export type JobDefinitionsState = NullableNumberInterface<JobDefinitionItem>[];

const initialState: JobDefinitionsState = [];

const jobDefinitionsSlice = createSlice({
  name: Slices.JOB_DEFINITIONS,
  initialState,
  reducers: {
    clearJobDefinitions: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobDefinitions.pending, () => {
        return initialState;
      })
      .addCase(getJobDefinitions.fulfilled, (_, { payload }) => {
        return normalizeJobDefinitions(payload);
      })
      .addCase(getJobDefinitions.rejected, () => {
        return initialState;
      });
  },
});

export const { clearJobDefinitions } = jobDefinitionsSlice.actions;

export default jobDefinitionsSlice.reducer;
